class CookieWallController {
    constructor($scope, ModalService, $timeout) {
        'ngInject';

        this.$scope = $scope;
        this.ModalService = ModalService;
        this.$timeout = $timeout;
    }

    $onInit() {
        this.$timeout(() => {
            this.detectCookies();
        }, 50);
    }

    openModal() {
        const modalRef = this.ModalService.add(
            null,
            `<cookie-wall-modal></cookie-wall-modal>`,
            null,
            false,
            'cookie-wall-modal'
        );

        modalRef.open();
    }

    detectCookies() {
        let isSet = this.getCookie('acceptCookies');
        if (!isSet) {
            this.openModal();
        }
    }

    getCookie(cname) {
        let name = cname + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }

            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }

        return "";
    }
}

let cookieWallComponent = {
    bindings: {},
    controller: CookieWallController
};

export default cookieWallComponent;
